import { useEffect } from 'react';

/**
 * Paint the browser chrome to match what is on screen underneath it - the
 * status bar of an installed app on iOS, the address bar on Android.
 *
 * The tag in each app's index.html holds the resting colour (the cream the
 * dashboard sits on). This swaps it for as long as the caller is mounted and
 * puts back whatever it found on the way out, so a screen cannot leave the
 * bar stranded on a colour that no longer matches anything.
 *
 * Deliberately a no-op when the tag is missing: the sales and brandOwner apps
 * ship no theme-color, and nothing here is worth creating one for.
 */
export const useThemeColor = (color: string) => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;

    const previous = meta.getAttribute('content');
    meta.setAttribute('content', color);

    return () => {
      if (previous !== null) meta.setAttribute('content', previous);
    };
  }, [color]);
};
